import { render, staticRenderFns } from "./salepricetsetting.vue?vue&type=template&id=3647e7b5&scoped=true&"
import script from "./salepricetsetting.vue?vue&type=script&lang=js&"
export * from "./salepricetsetting.vue?vue&type=script&lang=js&"
import style0 from "./salepricetsetting.vue?vue&type=style&index=0&id=3647e7b5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3647e7b5",
  null
  
)

export default component.exports